import { VIEW_MODE_STORAGE_KEY } from '../helpers/viewModePreference'

export const COOKIE_CONSENT_STORAGE_KEY = 'forpy_cookie_consent'
export const ANALYTICS_CONSENT_STORAGE_KEY = 'forpy-analytics-consent'

const PRESERVED_STORAGE_KEYS = [
  COOKIE_CONSENT_STORAGE_KEY,
  ANALYTICS_CONSENT_STORAGE_KEY,
  VIEW_MODE_STORAGE_KEY
]

export function clearLocalStoragePreservingConsent (): void {
  const preservedValues = PRESERVED_STORAGE_KEYS.map((key) => [key, window.localStorage.getItem(key)] as const)

  window.localStorage.clear()

  preservedValues.forEach(([key, value]) => {
    if (value !== null) {
      window.localStorage.setItem(key, value)
    }
  })
}
